import React, { useMemo } from "react";
import packageJson from "../../../package.json";
import getConfig from "../../config";
import { Environments, lowerEnvironments } from "../../shared/constants";

const VERSION_STRING = packageJson.version;

const LOWER_ENVIRONMENTS_SET = new Set(lowerEnvironments);

const AppVersion: React.FC = React.memo(() => {
    const isLowerEnv = useMemo(() => {
        const { appEnv } = getConfig();
        return appEnv ? LOWER_ENVIRONMENTS_SET.has(appEnv.toLowerCase() as Environments) : false;
    }, []);

    if (!isLowerEnv) {
        return null;
    }

    return (
        <div className="app-version">
            <small>{VERSION_STRING}</small>
        </div>
    );
});

AppVersion.displayName = "AppVersion";

export default AppVersion;
